<template>
    <Modal v-if="visible" @modal:close="handleCloseModal">
        <template #body>
            <div class="flex flex-col items-center">
                <img src="/img/cover-letter-ai-logo.png" class="w-[263px]" title="CoverLetter AI" />
                <div class="font-[Inter] font-bold text-2xl text-[#323232] mt-6">Welcome to CoverLetterAI!</div>
                <div class="font-[Inter] font-normal text-sm text-[#323232] mt-6 mx-2">Create your AI powered cover letter so you can impress recruiters with a professional introduction.</div>
            </div>
        </template>

        <template #actions>
            <won-button @click="handleStartOnboarding" class="w-full mt-2.5 justify-center font-medium font-[Roboto]">Begin</won-button>
        </template>
    </Modal>
</template>

<script setup>
import introJS from "intro.js";
import { ref } from 'vue'

import Modal from "../components/modal"
import WonButton from "../components/won-button"

import { introJsButton } from "../utils/styles"
import { coverletterOnboarding } from "../utils/onboarding";

import { useOnboardingStore } from '../store/onboarding.store'
import { useBulletGenerator } from '../store/bullet-store'

import { setAuthState } from "../composables/auth";
import { markCoverLetterPassed } from "../api/profile";

// check if the user passed home onboarding
const { getUser, setUser } = setAuthState()
const passed = getUser()?.options?.coverletter_passed
const visible = ref(!passed)

const onboardingStore = useOnboardingStore()
onboardingStore.markAsOnboarding(visible.value)

const bulletGenerator = useBulletGenerator()

const handleCloseModal = () => {
    visible.value = false

    bulletGenerator.setOpened(false)
    onboardingStore.markAsOnboarding(false)
    
    markCoverLetterPassed().then(() => {
        setUser({
            ...getUser(),
            options: {...getUser()?.options, ...{coverletter_passed: true}},
        })
    })
}

const handleStartOnboarding = async() => {
    // close modal
    visible.value = false

    await new Promise((resolve, reject) => setTimeout(() => resolve(), 100))

    const steps = coverletterOnboarding();

    const options = {
        disableInteraction: true,
        showBullets: true,
        exitOnOverlayClick: false,
        exitOnEsc: false,
        prevLabel: 'Previous',
        nextLabel: 'Next',
        doneLabel: "Finish",
        tooltipClass: 'onboarding-tooltip',
        buttonClass: introJsButton,
        steps,
    }

    const onExit = () => {
        onboardingStore.markAsOnboarding(false)
        onboardingStore.setOpenedCoverLetter(false)
        onboardingStore.setCurrentStep(null)
        
        markCoverLetterPassed().then(() => {
            setUser({
                ...getUser(),
                options: {...getUser()?.options, ...{coverletter_passed: true}},
            })
        })
    }

    // smart hack for bullet point generator
    const currentStep = ref(null)
    
    introJS()
        .onexit(onExit)
        .oncomplete(onExit)
        .onchange(targetElement => {
            onboardingStore.setCurrentStep(targetElement?.['id'] ?? null)
        })
        .onbeforechange(targetElement => {
            currentStep.value = targetElement.getAttribute('data-step')

            targetElement.scrollIntoView({
                block: "center",
                inline: "center",
            })

            // smal hack
            if(currentStep.value == 1 || currentStep.value == 2) {
                onboardingStore.setOpenedCoverLetter(true)
            } else if(currentStep.value == 3) {
                onboardingStore.setOpenedCoverLetter(false)
            }
        })
        .setOptions(options)
        .start()
}
</script>

<style scoped>
.page {
  background-color: #fff;
  margin: 40px auto 64px;
}
</style>
